module.exports = __webpack_public_path__ + "img/symbol_3.48e0c95a.png";